import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// The client's contracted service for a given type (or null), refetched when name/type change.
export const useContract = (name, typeId, enabled = true) => {
  const [contract, setContract] = useState(null);
  useEffect(() => {
    setContract(null);
    const n = (name || "").trim();
    if (!enabled || !n || !typeId) return undefined;
    let alive = true;
    const t = setTimeout(() => {
      api.get("/clients/services", { params: { name: n } })
        .then((r) => alive && setContract(r.data.find((c) => c.service_type === typeId) || null))
        .catch(() => {});
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [name, typeId, enabled]);
  return contract;
};
